import React from "react";
import { gql, useMutation } from "@apollo/client";
import {
  ForgotPasswordChangeMutationMutation,
  ForgotPasswordChangeMutationMutationVariables
} from "../../../../schemaTypes";

const FORGOT_PASSWORD_CHANGE_MUTATION = gql`
  mutation ForgotPasswordChangeMutation(
    $newPassword: String!,
    $confirmNewPassword: String!,
    $key: String!
  ) {
    forgotPasswordChange(
      newPassword: $newPassword, 
      confirmNewPassword: $confirmNewPassword,
      key: $key
    ) {
      errors {
        path
        message
      }
      message
    }
  }
`;

interface ChangePasswordControllerProps {
  children: (
    data: {
      submit: (
        values: ForgotPasswordChangeMutationMutationVariables
      ) => Promise<{
        errors: { path: string; message: string }[] | null;
        message: string | null;
      } | null>;
      loading: boolean;
      error?: Error;
    }
  ) => React.ReactElement | null;
}

export const ChangePasswordController: React.FC<ChangePasswordControllerProps> = ({ children }) => {
  const [forgotPasswordChangeMutation, { loading, error }] = useMutation<
    ForgotPasswordChangeMutationMutation,
    ForgotPasswordChangeMutationMutationVariables
  >(FORGOT_PASSWORD_CHANGE_MUTATION);

  const submit = async (values: ForgotPasswordChangeMutationMutationVariables) => {
    try {
      const { data } = await forgotPasswordChangeMutation({ variables: values });
      if (data?.forgotPasswordChange) {
        return {
          errors: data.forgotPasswordChange.errors
            ? data.forgotPasswordChange.errors.filter((e): e is { path: string; message: string } => e !== null).map(({ path, message }) => ({ path, message }))
            : null,
          message: data.forgotPasswordChange.message ?? null,
        };
      }
      return null;
    } catch {
      return null;
    }
  };

  return children({ submit, loading, error });
};